<template>
  <svg width="16" height="16" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Badges">
      <path
        id="Polygon 1"
        d="M5.27314 0.4493C5.57263 -0.149767 6.42737 -0.149766 6.72686 0.4493L11.9132 10.8237C12.1833 11.3641 11.7904 12 11.1863 12H0.813698C0.209589 12 -0.183324 11.3641 0.0868421 10.8237L5.27314 0.4493Z"
        fill="#F2B500"
      />
      <g id="Union">
        <path
          d="M6.375 4.875C6.375 4.66789 6.20711 4.5 6 4.5C5.79289 4.5 5.625 4.66789 5.625 4.875V7.875C5.625 8.08211 5.79289 8.25 6 8.25C6.20711 8.25 6.375 8.08211 6.375 7.875V4.875Z"
          fill="white"
        />
        <path
          d="M6 9.75C6.20711 9.75 6.375 9.58211 6.375 9.375C6.375 9.16789 6.20711 9 6 9C5.79289 9 5.625 9.16789 5.625 9.375C5.625 9.58211 5.79289 9.75 6 9.75Z"
          fill="white"
        />
      </g>
    </g>
  </svg>
</template>
